/* eslint-disable no-unused-vars */
import { FC } from 'react';
import { Select, Space, Avatar } from 'antd';
import { COUNTRY_CODES } from '../../const/countryCodes';

const { Option } = Select;

interface ICountryCodeSelector {
    defaultCountryCode?: string;
    disabled?: boolean;
    handleSelect: (value: string) => void;
}

const CountryCodeSelector: FC<ICountryCodeSelector> = ({
    handleSelect,
    defaultCountryCode,
    disabled,
}) => (
    <Select
        notFoundContent={null}
        showSearch
        placeholder="+593"
        defaultValue="+593"
        onChange={handleSelect}
        value={defaultCountryCode}
        disabled={disabled}
    >
        {
            COUNTRY_CODES.map((cc, index: number) => (
                <Option
                    key={index}
                    value={`+${cc.callingCodes}`}
                    label={`+${cc.callingCodes}`}
                >
                    <Space direction="horizontal" size={8} align="center">
                        <Avatar
                            src={cc.flag}
                            size={24}
                            shape="square"
                            alt={`+${cc.callingCodes}`}
                            style={{ verticalAlign: 'middle' }}
                        />
                        <span>
                            {`+${cc.callingCodes}`}
                        </span>
                    </Space>
                </Option>
            ))
        }
    </Select>
);

export { CountryCodeSelector };
